import Fetch from './Utils/Fetch';
import EventEmitter from './Utils/EventEmitter';
import Session from './Models/Session';
import Chat from './Models/Chat';
import SocketIO from './SocketIO/Events';
import Videoconf from './Videoconf/Manager';
import LocalStorage from './Utils/LocalStorage';

import { browserName, browserVersion } from 'react-device-detect';

export default class Sdk {
	
   
    constructor(params) {
        this._env = params.env;
        this._apiUrl = params.apiUrl;
        this._hocoSettingsUrl = params.hocoSettingsUrl || 'back.hocoia.app';
        this._session = new Session(this);
        this._fetch = new Fetch(this);
        this._event = new EventEmitter();        
		this._videoconf = new Videoconf(this);   
        this._socketIO = new SocketIO(this);
        this._chat = new Chat(this);
        this._hocoSettings = {};

        if ('onpagehide' in window) {
            window.addEventListener('pagehide', () => {                
                this.exit();   
            });
        }
        else {
            window.addEventListener('unload', () => {
                this.exit();   
            })
        }

        this._urlParams = new URLSearchParams(document.location.search);

        //does not work better
        /*
        window.addEventListener('beforeunload', () => {
            this.exit();   
        })*/

        window.addEventListener('resize', () => {            
            this.updateHeight();
        })

        
        window.addEventListener("touchstart", preventMotion, false);
        window.addEventListener("scroll", preventMotion, false);
        window.addEventListener("touchmove", preventMotion, false);

        function preventMotion(event)
        {
            if(!window.isDemoPage) {
                window.scrollTo(-1, 0);
                event.preventDefault();
                event.stopPropagation();
            }
        }
        
    }

    getUrlParam(key) {
        return this._urlParams.get(key);
    }

    exit() {
        if(this._videoconf.isStarted()) {
            this._videoconf._producers.closeAll();           
            this._videoconf.exit();
            this._socketIO.disconnect();
        }
    }

    async restart() {
        await this._videoconf.restartProducers();
        //setTimeout(() => {
        this._videoconf.restartConsumers();
        //}, 3000);
        //this._videoconf.restartConsumers();
    }

    kill() {
        this._fetch.post('/kill');
    }

    async loadHocoSettings(id) {
        //TODO change url
        this._hocoSettings = {};
        try {
            let response = await window.fetch('https://' + this._hocoSettingsUrl + '/points-of-care/' + id + '/hocovisio-settings');
            this._hocoSettings = await response.json();
        }
        catch(err) {
            console.log('loadHocoSettings error', err);
        }
        console.log('this._hocoSettings', this._hocoSettings)
        if(this._hocoSettings.available_devices) {
            let css = [];
            css.push('.capteur-show { display: none !important; }');
            for(var i in this._hocoSettings.available_devices) {
                css.push('.capteur-role-' + this._hocoSettings.available_devices[i] + ' { display: flex !important; }');
            }
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = css.join("\n");
            console.log('css', css)
            document.getElementsByTagName('head')[0].appendChild(style);
        }
    }

    getHocoSettings() {
        return this._hocoSettings;
    }

    async loadSettings() {
        this._settings = await this._fetch.get('/settings');
        console.log('this._settings', this._settings)
        this._settings.devices.sort((a,b) => a.order - b.order )
    }

    settings() {
        return this._settings;
    }
    
    async init() {
        console.log('this._urlParams', this._urlParams);
        if(this.getUrlParam('hocoSettings')) {
            console.log('load hocoSettings');
            await this.loadHocoSettings(window.sdk.getUrlParam('hocoSettings'));
          }
        await this.loadSettings();     
        
        this.updateHeight();
    }

    updateHeight() {
        let vh = window.innerHeight;        
        document.documentElement.style.setProperty('--height-vh', `${vh}px`);         
    }

    checkBrowser() { 
        let updateBrowser = false;

        const isSamsungBrowser = navigator.userAgent.indexOf('SamsungBrowser') > - 1;
        if(isSamsungBrowser)
            updateBrowser = true;
        
            switch(browserName) {
            case 'Chrome': 
                if(browserVersion < 58) {
                    updateBrowser = true;
                }
                break;
            case 'Firefox':
                if(browserVersion < 67) {
                    updateBrowser = true;
                }
                break;
            case 'Microsoft Edge': 
                if(browserVersion < 70) {
                    updateBrowser = true;
                }
                break;
            case 'Safari': 
                if(browserVersion < 11) {
                    updateBrowser = true;
                }
                break;
            case 'SamsungBrowser':
                updateBrowser = true;
                break;
        }
        if(updateBrowser === true){
            window.sdk.event().emit('browserOverdated')
        }
    }

    async connectSocketIO() {
        let res = await this._socketIO.connect(this._session.getToken());
        this.fetch().addGlobalHeader('X-Socket-Id', res.id);  

        return res;
    }
    
    getApiUrl() {
        return this._apiUrl;
    }
    
    fetch() {
        return this._fetch;
    }
    
    env() {
        return this._env;
    }
    
    session() {
        return this._session;
    } 

    chat() {
        return this._chat;
    } 
    
    event() {
        return this._event;
    }
    
    socket() {
        return this._socket;
    }
	
	videoconf() {
        return this._videoconf;
    }
	
	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

    lightbox(section) {
        window.sdk.event().emit('lightboxToggle', {section})
    }
    lightboxHtml(content){
        window.sdk.event().emit('lightboxToggle', {section:'html', content})
    }
    lightboxMedia(media,parent){
        window.sdk.event().emit('lightboxToggle', {section:'media',media,parent})
    }

    isInFullScreen() {
        return (
          (document.fullscreenElement && document.fullscreenElement !== null) ||
          (document.webkitFullscreenElement &&
            document.webkitFullscreenElement !== null) ||
          (document.mozFullScreenElement &&
            document.mozFullScreenElement !== null) ||
          (document.msFullscreenElement && document.msFullscreenElement !== null)
        );
      }
    
      toggleFullscreen () {
        const isInFullScreen = this.isInFullScreen();
        let el = document.body;
        if (!isInFullScreen) {    
            if (el.requestFullscreen) {
                el.requestFullscreen();
            } else if (el.mozRequestFullScreen) {
                el.mozRequestFullScreen();
            } else if (el.webkitRequestFullScreen) {
                el.webkitRequestFullScreen();
            } else if (el.msRequestFullscreen) {
                el.msRequestFullscreen();
            }
            return true;
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
          return false;
        }
      }
    
    
}